<template>
    <div ref="configViewRef">
        <p class="read-title" v-if="readonly">{{ objSelectRecommend.popupConfig.title }}</p>
        <div v-else>
            <BasicTitle v-if="objSelectRecommend.popupConfig" :title="objSelectRecommend.popupConfig.title"></BasicTitle>
        </div>

        <!--      选择按钮      -->
        <div v-if="!readonly && objSelectRecommend.popupConfig && !objSelectRecommend.needChose" class="chose-btn-wrap">
            <div v-for="btnItem in objSelectRecommend.popupConfig.choseBtn" :key="btnItem.typeKey" :style="{flex: btnItem.type === 'one' ? '0 0 auto' : '1 1 auto'}" class="btn-content">
                <div class="one-btn-group" v-if="btnItem.type === 'one'">
                    <div class="out-wrap" v-for="btn in btnItem.children" :key="btn.btnKey">
                        <input v-if="btn.input" class="one-btn input-mini btn-item mini-one-btn" @blur="btn.value =  Number.parseFloat(btn.value) ? Number.parseFloat(btn.value) + 'm' : ''" v-model="btn.value" :placeholder="btn.name">
                        <div v-else @click="handleConfigBtnChose(btnItem.typeKey,btn)" class="one-btn btn-item" :class="{'active-btn': btn.select ,'mini-one-btn': btnItem.mini }">{{ btn.name }}</div>
                    </div>

                </div>
                <div v-if="btnItem.type === 'double'" class="btn-group double btn-item">
                    <span @click="handleConfigBtnChoseDob(btnItem.typeKey,btn)" v-for="btn in btnItem.children" :key="btn.btnKey" :class="{'active-btn': btn.select}">{{ btn.name }}</span>
                </div>
            </div>
        </div>


        <div class="select-info" v-if="objSelectRecommend.popupConfig && objSelectRecommend.popupConfig.machinePosition">

            <!--       位置输入         -->
            <div class="position-input-content">
                <input :readonly="readonly" class="input-item" :placeholder="item.name" v-model="item.value" :key="item.key" v-for="item in activePositionArr">
                <div class="input-item btn-item" v-for="item in activePositionOneArr" :key="item.typeKey">{{ item.name }}</div>
            </div>


            <!--        位置图片上传        -->
            <div class="image-upload-wrap">
                <PositionLoadImage :key="item.key" @uploadImageToList="item.imageList.push($event);" @removeImageToList="removeImageToListFi($event,item)" :title="item.imageTitle" v-for="item in activePositionArr.filter(i=>i.imageList)" :readonly="!readonly" :imageList="item.imageList"></PositionLoadImage>
            </div>
        </div>

        <!--        附件设备数量        -->
        <div v-if="objSelectRecommend.needChose">
            <div v-for="keys in needChoseSubKeys" :key="keys" class="subjoin-product-wrap">
                <p class="sub-title">{{ objSelectRecommend.popupConfig[keys].subTitle }}</p>
                <!--              数量控制      -->
                <div v-if="!readonly" class="count-option">
                    <div class="count-title">设计数量</div>
                    <div class="count-wrap">
                        <img @click="addNeedChoseSubProductItem(keys)" class="count-icon" :src="require('@/assets/images/hvac/mapping/count-reduce-icon.png')" alt="">
                        <div disabled class="count-num">{{ needChoseSubProduct(keys).productList.length }}</div>
                        <img @click="addNeedChoseSubProductItem(keys,false)" class="count-icon" :src="require('@/assets/images/hvac/mapping/count-add-icon.png')" alt="">
                    </div>
                </div>
                <!--           产品列表和定位         -->
                <div class="product-wrap-content">
                    <div class="nav-wrap" @click="setNeedChoseProductSelect(item,keys)" :class="{'nav-wrap-active':item.select}" v-for="(item,index) in needChoseSubProduct(keys).productList" :key="item.key">{{ needChoseSubProduct(keys).productName + (index + 1) }}</div>
                </div>
                <input :readonly="readonly" :value="needChoseSubProductValue(keys)" @input="inputNeedChoseSubProductValue($event.target.value,keys)" class="position-input" placeholder="设计位置">
                <!--           位置照片         -->
                <PositionLoadImage title="位置照片" :readonly="!readonly" @uploadImageToList="uploadImageToProductList($event,keys)" @removeImageToList="removeImageToProductList($event,keys)" :imageList="activeProductNeedSubPositionImageList(keys)"></PositionLoadImage>
            </div>
        </div>
        <div v-else>
            <div v-for="keys in needChoseSubKeys" :key="keys" class="subjoin-product-wrap">
                <p class="sub-title">{{ objSelectRecommend.popupConfig[keys].subTitle }}</p>
                <!--              数量控制      -->
                <div v-if="!readonly" class="count-option">
                    <div class="count-title">设计数量</div>
                    <div class="count-wrap">
                        <img @click="addSubProduct" class="count-icon" :src="require('@/assets/images/hvac/mapping/count-reduce-icon.png')" alt="">
                        <div disabled class="count-num">{{ activeProductSubArr.length }}</div>
                        <img @click="addSubProduct(false)" class="count-icon" :src="require('@/assets/images/hvac/mapping/count-add-icon.png')" alt="">
                    </div>
                </div>
                <!--           产品列表和定位         -->
                <div class="product-wrap-content">
                    <div @click.stop="setProductSelect(item)" class="nav-wrap" :class="{'nav-wrap-active':item.select}" v-for="(item,index) in objSelectRecommend.popupConfig[keys].productList" :key="item.key">{{ objSelectRecommend.popupConfig[keys].productName + (index + 1) }}</div>
                </div>
                <input :readonly="readonly" class="position-input" v-model="activeProductSubPositionValue" placeholder="设计位置">
                <!--           位置照片         -->
                <PositionLoadImage title="位置照片" :readonly="!readonly" @uploadImageToList="uploadImageToProductList" @removeImageToList="removeImageToProductList" :imageList="activeProductSubPositionImageList"></PositionLoadImage>

            </div>
        </div>
        <!--     膨胀罐信息      -->
        <div v-if="objSelectRecommend.popupConfig && objSelectRecommend.popupConfig.inflationInfo && isInflationInfoSelect" class="inflation-info-wrap">
            <p class="info-title">{{ objSelectRecommend.popupConfig.inflationInfo.title }}</p>
            <input :readonly="readonly" class="position-input" v-model="objSelectRecommend.popupConfig.inflationInfo.positionValue" placeholder="设计位置">
            <!--            位置照片        -->
            <PositionLoadImage title="位置照片" @uploadImageToList="uploadImageFloatToList" @removeImageToList="removeImageToFloatList" :readonly="!readonly" :imageList="objSelectRecommend.popupConfig.inflationInfo.imageList"></PositionLoadImage>
        </div>

        <!--        提交        -->
        <div v-if="!readonly && objSelectRecommend.popupConfig" class="confirm-btn-wrap">
            <div class="btn" @click="handleCommitRecommend">提交</div>
        </div>

    </div>
</template>

<script>
import BasicTitle from './basictitle';
import PositionLoadImage from './positionloadimage'
import {mapState} from "vuex";
import {Dialog} from "vant";

export default {
    name: "machineConfigView",
    components: {
        BasicTitle,
        PositionLoadImage,
    },
    props: {
        // 父级传递
        selectRecommend: {
            type: Object,
            default: () => ({})
        },
        // 只读
        readonly: Boolean
    },
    data() {
        return {
            // 当前选择的配置项，是配置推荐渲染其元素
            objSelectRecommend: {},
        }
    },
    watch: {
        /**
         * 监听父级传递的变化
         */
        selectRecommend: {
            handler(v) {
                this.objSelectRecommend = JSON.parse(JSON.stringify(v));
            },
            immediate: true,
        }
    },
    computed: {
        ...mapState({
            // 配置推荐渲染
            arrRecommended: state => state.hvacMappingEntry.arrRecommended,
        }),
        /**
         * 需要配置的列表
         */
        needChoseSubKeys() {
            return this.objSelectRecommend.popupConfig.choseBtn.find(i => i.type === 'double').children.filter(i => i.select && i.subProductKey).map(i => i.subProductKey)
        },
        /**
         * 获取当前激活的单选项
         */
        activePositionArr() {
            const selectDoubleBtnKey = this.objSelectRecommend.popupConfig.choseBtn.find(i => i.type === 'double').children.find(i => i.select)?.btnKey;
            const selectOneInput = this.readonly ? this.objSelectRecommend.popupConfig.choseBtn.find(i => i.type === 'one')?.children.filter(i => i.input) : [];
            const target = this.objSelectRecommend.popupConfig?.machinePosition.find(i => i.doubleKey === selectDoubleBtnKey)?.children;

            return target ? [...target, ...selectOneInput] : [];
        },
        /**
         * 获取当前激活的多选项
         */
        activePositionOneArr() {
            // inflationInfo 膨胀罐
            return this.readonly ? this.objSelectRecommend.popupConfig.choseBtn.find(i => i.type === 'one').children.filter(i => i.select && !i.inflationInfo) : [];
        },
        /**
         * 获取当前附加的产品列表
         */
        activeProductSubArr: {
            get() {
                return this.objSelectRecommend.popupConfig[this.selectDoubleProductKey].productList;
            },
            set(v) {
                this.objSelectRecommend.popupConfig[this.selectDoubleProductKey].productList = v;
            }
        },
        /**
         * 单选按钮的附加产品key
         * @returns {string|*}
         */
        selectDoubleProductKey() {
            return this.objSelectRecommend.popupConfig.choseBtn.find(i => i.type === 'double').children.find(i => i.select)?.subProductKey;
        },
        /**
         * 获取当前附加的产品列表的激活项的定位值
         * @returns string
         */
        activeProductSubPositionValue: {
            get() {
                return this.activeProductSubArr.find(i => i.select).positionValue;
            },
            set(v) {
                this.activeProductSubArr = this.activeProductSubArr.map(i => {
                    if (i.select) i.positionValue = v;
                    return i;
                });
            }
        },
        /**
         * 获取当前附加的产品列表的激活项的图片列表
         */
        activeProductSubPositionImageList() {
            return this.activeProductSubArr.find(i => i.select).imageList;
        },
        /**
         * 是否选择膨胀罐
         */
        isInflationInfoSelect() {
            return this.objSelectRecommend.popupConfig.choseBtn.find(i => i.type === 'one').children.some(i => i.inflationInfo && i.select)
        }
    },
    methods: {
        /**
         * 获取当前附加的产品列表的激活项的图片列表
         */
        activeProductNeedSubPositionImageList(key) {
            return this.needChoseSubProduct(key).productList.find(i => i.select).imageList;
        },
        /**
         * 设置double附加产品激活
         * @param item
         * @param key
         */
        setNeedChoseProductSelect(item, key) {
            this.objSelectRecommend.popupConfig[key].productList = this.objSelectRecommend.popupConfig[key].productList.map(i => {
                i.select = i.key === item.key;
                return i;
            });
        },
        /**
         * 多选double类型产品列表对应的input值输入
         * @param value
         * @param key
         */
        inputNeedChoseSubProductValue(value, key) {
            this.objSelectRecommend.popupConfig[key].productList.find(i => i.select).positionValue = value;
        },
        /**
         * 多选double类型产品列表对应的input值
         */
        needChoseSubProductValue(key) {
            return this.objSelectRecommend.popupConfig[key].productList.find(i => i.select).positionValue;
        },
        /**
         * 添加多选double类型产品列表项
         */
        addNeedChoseSubProductItem(key, reduce = true) {
            const target = this.objSelectRecommend.popupConfig[key];
            const {parentId, subId} = target.productList[0];
            const len = target.productList.length;
            // 减去
            if (reduce) {
                // 是否要限制数量？
                len > 1 && target.productList.pop();
            } else {
                const item = {
                    key: (len + 1).toString(),
                    select: !len,
                    positionValue: '',
                    imageList: [],
                    parentId, subId
                };
                target.productList.push(item)
            }
        },

        /**
         * 多选double类型产品列表
         * @param key
         */
        needChoseSubProduct(key) {
            return this.objSelectRecommend.popupConfig[key];
        },
        /**
         * 处理第一排的多选配置按钮点击
         * @param prentKey
         * @param item
         */
        handleConfigBtnChose(prentKey, item) {
            this.objSelectRecommend.popupConfig.choseBtn = this.objSelectRecommend.popupConfig.choseBtn.map(prent => {
                if (prent.typeKey === prentKey) {
                    prent.children = prent.children.map(btn => {
                        prent.type === 'one' && (btn.select = btn.btnKey === item.btnKey ? !btn.select : !!btn.select);
                        return btn;
                    });
                }
                return prent;
            })
        },
        /**
         * 处理第一排的多选配置按钮点击
         * @param prentKey
         * @param item
         */
        handleConfigBtnChoseDob(prentKey, item) {
            this.objSelectRecommend.popupConfig.choseBtn = this.objSelectRecommend.popupConfig.choseBtn.map(prent => {
                if (prent.typeKey === prentKey) {
                    prent.children = prent.children.map(btn => {
                        if (prent.type === 'double') {
                            btn.select = btn.btnKey === item.btnKey;
                        }
                        return btn;
                    });
                }
                return prent;
            })
        },
        /**
         * 移除图片
         */
        removeImageToListFi(result, item) {
            item.imageList = item.imageList.filter(i => i.img_url !== result.img_url)
        },
        /**
         * 控制产品的加减
         * @param reduce
         */
        addSubProduct(reduce = true) {
            const len = this.activeProductSubArr.length;

            const {parentId, subId} = this.activeProductSubArr[0];

            // 减去
            if (reduce) {
                // 是否要限制数量？
                len > 1 && this.activeProductSubArr.pop();
            } else {
                const item = {
                    parentId,
                    subId,
                    key: (len + 1).toString(),
                    select: !len,
                    positionValue: '',
                    imageList: [],
                };
                this.activeProductSubArr.push(item)
            }
        },
        /**
         * 设置附加产品激活
         * @param item
         */
        setProductSelect(item) {
            this.activeProductSubArr = this.activeProductSubArr.map(i => {
                i.select = i.key === item.key;
                return i;
            })
        },
        /**
         * 移除附加产品列表的图片
         */
        removeImageToProductList(result, key) {
            if (key) {
                this.needChoseSubProduct(key).productList.some(i => {
                    if (i.select) {
                        i.imageList = i.imageList.filter(item => item.img_url !== result.img_url);
                        return true;
                    }
                });
            } else {
                this.activeProductSubArr.some(i => {
                    if (i.select) {
                        i.imageList = i.imageList.filter(item => item.img_url !== result.img_url);
                        return true;
                    }
                });
            }
        },
        /**
         * 增加附加产品列表的图片
         */
        uploadImageToProductList(result, key) {
            if (key) {
                this.needChoseSubProduct(key).productList.find(i => {
                    i.select && i.imageList.push(result);
                })
            } else {
                this.activeProductSubArr.find(i => {
                    i.select && i.imageList.push(result);
                })
            }
        },
        /**
         * 移除膨胀罐的图片
         */
        removeImageToFloatList(result) {
            this.objSelectRecommend.popupConfig.inflationInfo.imageList = this.objSelectRecommend.popupConfig.inflationInfo.imageList.filter(item => item.img_url !== result.img_url);
        },
        /**
         * 增加膨胀罐的图片
         */
        uploadImageFloatToList(result) {
            this.objSelectRecommend.popupConfig.inflationInfo.imageList.push(result);
        },
        /**
         * 提交点击
         */
        async handleCommitRecommend() {
            // 验证必填项
            const {canNext} = this.validInputRecommend();

            if (!canNext) {
                return Dialog({message: '设计位置和位置照片为必填项'});
            }

            this.objSelectRecommend.edit = true;

            const list = this.arrRecommended.map(i => i.key === this.objSelectRecommend.key ? this.objSelectRecommend : i);

            await this.$store.dispatch({type: 'hvacMappingEntry/sendReportPositionFet', info: this.objSelectRecommend});

            this.$store.commit({type: 'hvacMappingEntry/CHANGE_RECOMMENDED_LIST', list});
            this.$emit('commitRecommend');
        },
        /**
         * 验证输入的报告
         */
        validInputRecommend() {
            const {choseBtn, inflationInfo, machinePosition} = this.objSelectRecommend.popupConfig;
            const canNext = [];
            let message;

            // 验证单选
            choseBtn.forEach(chose => {
                if (chose.type === 'double') {
                    const select = chose.children.find(i => i.select);
                    // 附加设备
                    if (this.objSelectRecommend.needChose) {
                        // 可选
                        canNext[0] = chose.children.filter(i => i.select).map(i => i.subProductKey).every(subKey => this.objSelectRecommend.popupConfig[subKey].productList.every(i => i.positionValue && i.imageList.length));
                    } else {
                        // 单选
                        canNext[0] = select.subProductKey ? this.objSelectRecommend.popupConfig[select.subProductKey]?.productList.every(i => i.positionValue && i.imageList.length) : true;
                    }
                    // 多选
                    canNext[1] = machinePosition ? machinePosition.find(i => i.doubleKey === select.btnKey).children.every(i => i.value && i.imageList.length) : true;

                } else {
                    const isInflationInfo = chose.children.find(i => i.select && i.inflationInfo);
                    canNext[2] = !isInflationInfo;
                    // 膨胀罐
                    if (isInflationInfo) {
                        canNext[2] = !!inflationInfo.positionValue && inflationInfo.imageList.length;
                    }
                }
            });

            return {canNext: canNext.every(i => i), message};
        }
    }
}
</script>

<style scoped lang="scss">

.read-title {
    font-weight: 500;
    line-height: 40px;
    margin-bottom: 16px;
}

.chose-btn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 24px 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-content {
        flex: 0;
        display: flex;
        align-items: center;
        margin-right: 20px;

        &:last-of-type {
            flex: 1;
            margin-right: 0;
        }

        .btn-item {
            color: #A2A2A2;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: $commonRadius;
        }

        .one-btn-group {
            display: flex;
            align-items: center;

            .out-wrap {
                margin-right: 20px;

                &:last-of-type {
                    margin-right: 0;
                }
            }

            .one-btn {

                background: #F7F7F7;
                text-align: center;
                padding: 0 12px;
                width: 206px;


            }

            .mini-one-btn {
                width: 150px;
                padding: 0 30px;
                line-height: 32px;
            }

            .input-mini {
                padding: 0;

                &::placeholder {
                    font-size: 20px;
                }
            }
        }

        .double {
            flex: 1;
            display: flex;
            font-size: 24px;
            color: $deepGreen;
            border: 1px solid $deepGreen;
            overflow: hidden;


            span {
                flex: 1;
                line-height: 80px;
                text-align: center;
                border-right: 1px solid $deepGreen;

                &:last-of-type {
                    border-right: none;
                }
            }
        }

        .active-btn {
            background: $deepGreen !important;
            color: #FFFFFF;
        }
    }
}


.select-info {
    padding-bottom: 1px;
    background: linear-gradient(to right, #F1F1F1 50%, transparent 50%) repeat-x bottom left / 20px 2px;

    .position-input-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 4px;

        .input-item {
            flex: 1;
            height: 80px;
            min-width: 316px;
            text-align: center;
            background: #F7F7F7;
            margin-right: 22px;
            margin-bottom: 20px;
            border-radius: $commonRadius;
            padding: 20px;

            &:nth-child(2n + 2) {
                margin-right: 0;
            }

            &::placeholder {
                color: #A2A2A2;
            }
        }

        .btn-item {
            flex: 0 0 316px;
        }
    }

    .image-upload-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;


        .image-content {
            flex: 1;
            margin-right: 22px;

            &:last-of-type {
                margin-right: 0;
            }


        }
    }
}

.confirm-btn-wrap {
    padding: 34px 34px 0;
    //background: linear-gradient(to right, #F1F1F1 50%, transparent 50%) repeat-x top left / 20px 2px;

    .btn {
        width: 328px;
        height: 80px;
        background: $userBgGradient;
        border-radius: $commonRadius;
        line-height: 80px;
        text-align: center;
        color: white;
        margin: 0 auto;
    }
}

.subjoin-product-wrap {
    padding-top: 28px;
    padding-bottom: 24px;
    background: linear-gradient(to right, #F1F1F1 50%, transparent 50%) repeat-x bottom left / 20px 2px;


    .sub-title {
        line-height: 40px;
        margin-bottom: 24px;
        font-weight: 500;
    }

    .count-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 26px;

        .count-title {
            flex: 0 0 max-content;
        }

        .count-wrap {
            display: flex;
            align-items: center;

            .count-icon {
                width: 60px;
                height: 60px;
            }

            .count-num {
                height: 60px;
                width: 212px;
                line-height: 60px;
                text-align: center;
                background: #F7F7F7;
                margin: 0 20px;
            }
        }
    }

    .product-wrap-content {
        display: flex;
        align-items: center;
        overflow-x: auto;
        padding-bottom: 28px;

        .nav-wrap {
            height: 46px;
            line-height: 34px;
            padding-bottom: 12px;
            font-size: $smallSize;
            width: max-content;
            flex: 0 0 auto;
            margin-right: 60px;

            &:last-of-type {
                margin-right: 0;
            }
        }

        .nav-wrap-active {
            color: $deepGreen;
            background: $userBgGradient no-repeat bottom center / 98% 4px;

        }
    }

    .position-input {
        padding: 0 10px;
        height: 80px;
        text-align: center;
        width: 100%;
        border-radius: $commonRadius;
        background: #F7F7F7;
        margin-bottom: 24px;

        &::placeholder {
            color: #A2A2A2;
        }
    }


}

.inflation-info-wrap {
    padding-top: 28px;
    padding-bottom: 24px;
    background: linear-gradient(to right, #F1F1F1 50%, transparent 50%) repeat-x bottom left / 20px 2px;


    .info-title {
        line-height: 40px;
        margin-bottom: 16px;
    }

    .position-input {
        padding: 0 10px;
        height: 80px;
        text-align: center;
        width: 100%;
        border-radius: $commonRadius;
        background: #F7F7F7;
        margin-bottom: 24px;

        &::placeholder {
            color: #A2A2A2;
        }
    }

}


</style>